<div class="tabs__grid-item">
  <interconnect-summary
    [service]="service()"
    [subscriptionInstanceId]="endpoint().subscriptionInstanceId ?? undefined"
    [forceTrafficBottom]="hasConfigurationDetails()"
    style="width: 100%"
  />
</div>

@if (hasConfigurationDetails()) {
  <div class="tabs__grid-item">
    <configuration-details
      [configurationDetails]="configurationDetails()"
      [isInfrastructureDelegate]="false"
      [firewallEnabled]="false"
    />
  </div>
}
